import script from "./EditDocumentSubjectView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditDocumentSubjectView.vue?vue&type=script&setup=true&lang=ts"

import "./EditDocumentSubjectView.vue?vue&type=style&index=0&id=0accc1ea&lang=scss"

const __exports__ = script;

export default __exports__